import { loginDto, loginResult } from "../Interfaces/loginInterfaces";
import { deleteRequest, postRequest } from "./requestTemplates";

export const login = async (loginValues: loginDto): Promise<loginResult> =>
  postRequest("/v1/authenticate/login", loginValues);

export const logout = async (token: string) =>
  deleteRequest(`/v1/authenticate/logout?access_token=${token}`);
